export function font(size: number) {
  return `${size}px -apple-system, BlinkMacSystemFont, sans-serif`;
}
